export default {
  applicant: 'applicant',
  organization: 'organization',
  pass: 'pass',
  tangibles: 'tangibles',
  visitors: 'visitors',
  edit: 'edit',
  apply: 'apply',
  approve: 'approve',
  transport: 'transport'
}
